import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { useSelector, useDispatch } from 'react-redux'
import { AppDrawer, AppToolbar } from '~/views/shared'
import { closeDrawer } from '~/state/modules/app'
import { useStyles } from './AppContainer.style'
import { loadProfile } from '~/state/modules/profiles'
import { useTheme, useMediaQuery } from '@material-ui/core'

export const AppContainer = ({ children, title }) => {
  const { isDrawerOpen, isSidebarCollapsed } = useSelector((state) => state.app)
  const dispatch = useDispatch()
  const theme = useTheme()
  const isUpMedium = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true })
  const drawerWidth = isUpMedium && !isSidebarCollapsed ? 240 : 72
  const classes = useStyles({ drawerWidth })
  const [prevScrollY, setPrevScrollY] = useState(0)
  const [isScrollingDown, setIsScrollingDown] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const isScrollingDown = window.scrollY > prevScrollY
      setIsScrollingDown(isScrollingDown)
      setPrevScrollY(window.scrollY)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [prevScrollY])

  useEffect(() => {
    setPrevScrollY(0)
    setIsScrollingDown(false)
  }, [])

  useEffect(() => {
    dispatch(loadProfile())
  }, [dispatch])

  return (
    <main className={classes.container}>
      <div className={classes.sideBar}>
        <AppDrawer
          closeDrawer={() => dispatch(closeDrawer())}
          isOpen={isDrawerOpen}
        />
      </div>
      <div className={classes.appContent}>
        <div
          className={clsx({
            [classes.toolbarWrapper]: true,
            [classes.scrollEffectDown]: isScrollingDown
          })}>
          <AppToolbar title={title || 'ticketPass Manager'} />
        </div>
        <div className={classes.content}>{children}</div>
      </div>
    </main>
  )
}
